import { Fragment, useEffect, useRef } from 'react';

import { useAppSelector, useAppDispatch } from '../../store/hooks';
import {
    updateField,
    selectConfigState,
    recalcValues
} from './calculatorSlice';
import { Panel, FlexboxGrid } from 'rsuite';
import { CalculatorSettings } from './CalculatorSettings';
import { ComponentFactory } from '../../Components/ComponentFactory';
import { CalculatorAdditionalSettingsMethods, CalculatorCommonMethods, CalculatorGainLossMethods, CalculatorMethods } from './CalculatorMethods';
import "./Calculator.scss"


export const Calculator = () => {
    const state = useAppSelector(selectConfigState);
    const dispatch = useAppDispatch();
    const mounted: any = useRef()
    useEffect(() => {

        // This code will run when the component is mounted
        if (!mounted.current) {
            mounted.current = true;
            dispatch(recalcValues())
        }
        // Perform any initialization tasks here, such as fetching data
        // or subscribing to events

        return () => {
            // This code will run when the component is unmounted
            // Perform any cleanup tasks here, such as unsubscribing from events
        };
    }, [dispatch]); // The empty dependency array ensures that the effect runs only once


    const handleChange = (val: any, id: string) => {
        dispatch(updateField({ val, id }))
        dispatch(recalcValues())
    }
    return (
        <Panel bordered shaded className="calculator_panel">
            {CalculatorSettings.rows.map((component: any) => {
                let titleClassName = "calculator_flex_grid__title"
                if (component.titleAlign) {
                    titleClassName = `${titleClassName} calculator_flex_grid__title--${component.titleAlign}`
                }
                const flexBoxGridClassName = `calculator_flex_grid ${component.id}`
                const isVisible = CalculatorCommonMethods(component.id)?.isVisible ? CalculatorCommonMethods(component.id)?.isVisible() : true
                if (isVisible) {
                    return <FlexboxGrid className={flexBoxGridClassName} justify="start" align="middle" key={component.id}>
                        <FlexboxGrid.Item className="image_section" colspan={2}>{component.imageSettings ? <ComponentFactory component={component.imageSettings} /> : <></>}</FlexboxGrid.Item>
                        <FlexboxGrid.Item className={titleClassName} colspan={8}><strong>{component.name}</strong></FlexboxGrid.Item>
                        {component.additionalSettings ?
                            <>
                                <FlexboxGrid.Item colspan={8} className="config_section">
                                    <ComponentFactory
                                        methods={CalculatorMethods}
                                        component={component}
                                        allState={state}
                                        componentState={state[component.id]}
                                        onChange={(val: any) => handleChange(val, component.id)}
                                    /></FlexboxGrid.Item>
                                <FlexboxGrid.Item colspan={6} className="additional_settings_section">
                                    <ComponentFactory
                                        methods={CalculatorAdditionalSettingsMethods}
                                        allState={state}
                                        componentState={state[component.additionalSettings.id]}
                                        component={component.additionalSettings}
                                        onChange={(val: any) => handleChange(val, component.additionalSettings.id)}
                                    /></FlexboxGrid.Item>
                                <FlexboxGrid.Item colspan={24} className="gain_loss_section">
                                    <ComponentFactory
                                        methods={CalculatorGainLossMethods}
                                        allState={state}
                                        componentState={state[component.gainLossSettings.id]}
                                        component={component.gainLossSettings}
                                        onChange={(val: any) => handleChange(val, component.gainLossSettings.id)}
                                    /></FlexboxGrid.Item>
                            </>
                            : <>
                                <FlexboxGrid.Item colspan={8} className="config_section">
                                    <ComponentFactory
                                        methods={CalculatorMethods}
                                        component={component}
                                        allState={state}
                                        componentState={state[component.id]}
                                        onChange={(val: any) => handleChange(val, component.id)}
                                    /></FlexboxGrid.Item>
                                <FlexboxGrid.Item colspan={6} className="gain_loss_section">
                                    <ComponentFactory
                                        methods={CalculatorGainLossMethods}
                                        allState={state}
                                        componentState={state[component.gainLossSettings.id]}
                                        component={component.gainLossSettings}
                                        onChange={(val: any) => handleChange(val, component.gainLossSettings.id)}
                                    /></FlexboxGrid.Item>
                            </>


                        }
                    </FlexboxGrid>
                } else {
                    return <Fragment key={component.id}/>
                }

            })}
        </Panel>

    );
}
